module.exports = __webpack_public_path__ + "img/nina.7d304e2f.png";